<template>
  <div class="confirmation-city-picker">
    <div class="confirmation-city-picker__title txt-subtitle txt-blue-common">
      Ваш регион
    </div>
    <div
      v-if="city"
      class="confirmation-city-picker__city"
    >
      {{ city }}
    </div>
    <div class="confirmation-city-picker__description">
      Укажите ваш город, чтобы мы рассчитали зону доставки товаров
    </div>

    <div class="confirmation-city-picker__footer">
      <button
        type="button"
        class="btn-ui btn-ui--full-mob"
        @click="onContinue"
      >
        Продолжить
      </button>
      <button
        type="button"
        class="btn-ui btn-ui--secondary btn-ui--full-mob"
        @click="$emit('on-edit')"
      >
        Нет, изменить
      </button>
    </div>
  </div>
</template>

<script>
import { mainApi } from '../../../api';
import { sendEventYM } from '../../../utils/common';

export default {
  name  : 'ConfirmationCityPicker',
  props : {
    location: {
      type     : Object,
      required : true,
      default  : null
    },
    city: {
      type    : String,
      default : ''
    }
  },
  created() {
    this.setLocation();
  },
  methods: {
    setLocation() {
      if (this.location && this.location.id) {
        mainApi.modules.selectCity.setCity({ code: this.location.id });
      }
    },

    onContinue() {
      sendEventYM('confirmed_city_choice', {
        confirmed_city_choice_param: 'continue'
      });

      this.$emit('on-close');
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../css/redesign/utils/variables";
@import "../../../../../css/redesign/utils/grid";

.confirmation-city-picker {
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 24px;

  @include media-breakpoint-down(xsl) {
    padding-top: 8px;
  }
  &__city {
    font-size: 20px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: -1px;
    color: $c-blue-common;
  }
  &__description {
    font-size: 14px;
    line-height: 1.1;
    letter-spacing: -0.28px;
    color: $txt-secondary-on-wite;
  }
  &__footer {
    display: flex;
    position: relative;
    column-gap: 16px;

    @include media-breakpoint-down(xsl) {
      padding-top: 16px;
    }
    &:after {
      @include media-breakpoint-down(xsl) {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: -16px;
        right: -16px;
        height: 1px;
        background-color: $c-gray-on-wite;
      }
    }
  }
}
</style>
